import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

function* handleAccount(action) {
  const { meta } = action;

  if (meta.filter === "client.copyToClipboard") {
    yield put({
      type: ACTIONS.OPEN_SNACKBAR,
      payload: {
        variant: "info",
        message: `client key copied to clipboard`
      }
    });
  }
}

export function* accountWatcher() {
  yield takeEvery(ACTIONS.ACCOUNT, handleAccount);
}



// WEBPACK FOOTER //
// ./src/sagas/account.js